module.exports = "/img/4.svg?442c6e1df8ff67c273146ef98c2ed2c7";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/spinner/img/4.svg
// module id = zT3d
// module chunks = 83